import { createContext, useContext, useEffect, useState } from "react";

export const themes = {
  sand: {
    id: "sand",
    label: "Sand bar",
    hero: "/defaults/hero.svg",
    saturday: "/defaults/saturday.svg",
    sunday: "/defaults/sunday.svg",
    luncheon: "/defaults/luncheon.svg",
    gallery: "/defaults/gallery.svg",
  },
  ocean: {
    id: "ocean",
    label: "Ocean band",
    hero: "/defaults/ocean/hero.svg",
    saturday: "/defaults/ocean/saturday.svg",
    sunday: "/defaults/ocean/sunday.svg",
    luncheon: "/defaults/ocean/luncheon.svg",
    gallery: "/defaults/ocean/gallery.svg",
  },
  program: {
    id: "program",
    label: "Program",
    hero: "/defaults/program/hero.svg",
    saturday: "/defaults/program/saturday.svg",
    sunday: "/defaults/program/sunday.svg",
    luncheon: "/defaults/program/luncheon.svg",
    gallery: "/defaults/program/gallery.svg",
  },
};

const ThemePreviewContext = createContext(null);

export function ThemePreviewProvider({ children }) {
  const [template, setTemplate] = useState(() => sessionStorage.getItem("hbc-header-template") || "sand");
  const theme = themes[template] || themes.sand;

  useEffect(() => {
    document.documentElement.dataset.theme = theme.id;
  }, [theme.id]);

  const chooseTemplate = (id) => {
    sessionStorage.setItem("hbc-header-template", id);
    setTemplate(id);
  };

  return (
    <ThemePreviewContext.Provider value={{ template: theme.id, chooseTemplate, images: theme }}>
      {children}
    </ThemePreviewContext.Provider>
  );
}

export function useThemePreview() {
  return useContext(ThemePreviewContext);
}
